export default "__VITE_ASSET__Dxq9PMA$__"